<template>
  <fragment>
    <hero-header page-name="mainNavBar.career" hero-title="mainNavBar.generalInformations"/>
    <!-- INTRO SECTION START -->
    <v-container class="my-5">
      <v-container class="my-5">
        <v-row>
          <v-col cols="12" md="6">
            <div v-html="$t('pageCareerGeneralInfos.part1')"></div>
          </v-col>
          <v-col cols="12" md="6">
            <video controls="controls" :poster="require('../assets/tmx_hr_video_cover2.png')" width="100%">
              <source :src="`${publicPath}tmx_video/TMXTechnicianRecruitment.mp4`" type="video/mp4">
<!--              <source :src="`${publicPath}tmx_video/V2_Kingaval.webm`" type="video/webm">-->
              Your browser does not support HTML5 video.
            </video>
            <!--v-img :src="require('../assets/placeholder_3.jpg')" aspect-ratio="1.778" /-->
          </v-col>
          <v-col cols="12">
            <div v-html="$t('pageCareerGeneralInfos.part2')"></div>
          </v-col>
          <!--<v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <v-img :src="require('../assets/placeholder_3.jpg')" aspect-ratio="2" />
              </v-col>
              <v-col cols="6">
                <v-img :src="require('../assets/placeholder_4.jpg')" aspect-ratio="1" />
              </v-col>
              <v-col cols="6">
                <v-img :src="require('../assets/placeholder_5.jpg')" aspect-ratio="1" />
              </v-col>
            </v-row>
          </v-col>-->
        </v-row>
      </v-container>
    </v-container>
    <!-- INTRO SECTION START -->
    <!-- INFORMATION STRIP START -->
    <div id="valami" v-if="$i18n.locale == 'hu-HU'">
      <information-strip title="seeJobOffers" button-text="button.view" button-link="/career/job-offers" />
    </div>
    <!-- INFORMATION STRIP END -->
    <!-- ELVARASOK SECTION START -->
    <v-container class="my-5">
      <fancy-headline title="generalRequirements"/>
      <v-row>
        <v-col cols="12" sm="7">
          <div class="mb-10" v-html="$t('pageCareerGeneralInfos.part3')"></div>
          <div class="mb-10" v-html="$t('pageCareerGeneralInfos.part4')"></div>
          <div class="mb-10" v-html="$t('pageCareerGeneralInfos.part5')"></div>
        </v-col>
        <v-col cols="12" sm="5">
          <v-row>
            <v-col cols="12">
              <v-img :src="require('../assets/placeholder_4.jpg')" aspect-ratio="2"/>
            </v-col>
            <v-col cols="6">
              <v-img :src="require('../assets/placeholder_5.jpg')" />
            </v-col>
            <v-col cols="6">
              <v-img :src="require('../assets/tmx_warehouse2.jpg')" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <!-- ELVARASOK SECTION START -->
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import fancyHeadline from '../components/fancyHeadline.vue';
import informationStrip from '../components/informationStrip.vue';

export default {
  name: 'career',
  components: {
    heroHeader,
    fancyHeadline,
    informationStrip,
  },
  async beforeMount() {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
